import { render, staticRenderFns } from "./PerfilMiUnivisionario.vue?vue&type=template&id=56882030&"
import script from "./PerfilMiUnivisionario.vue?vue&type=script&lang=js&"
export * from "./PerfilMiUnivisionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports